export default "__VITE_ASSET__ByK_ZXqQ__"